import { createContext } from 'react';

const RoleManagementContext = createContext();

export default RoleManagementContext;
